import React, { Component } from 'react'
import styled from 'styled-components'

class ActivityFour extends Component {
  render() {
    return (
      <RootView>
        <BgImage src={require('./images/activity-content-four.png')} />
      </RootView>
    )
  }
}

export default ActivityFour

const RootView = styled.div`
    background-color: white;
    flex-direction:column;
    width:100%;
    height:100%;
  `
const BgImage = styled.img`
    width:100%;
  `



// WEBPACK FOOTER //
// ./src/modules/activity/components/activityFour.js